import { j as e } from "./jsx-runtime-944c88e2.js";
import * as o from "react";
const V = o.forwardRef(function(l, x) {
  const {
    label: c,
    id: n,
    defaultValue: r,
    required: b,
    width: j,
    helperText: a,
    error: N,
    name: g,
    onChange: i,
    onFocus: u,
    onBlur: d,
    ...I
  } = l, h = b ? `${c} *` : c, C = j || "inherit", [f, m] = o.useState(!1), [p, F] = o.useState(r), $ = (s) => {
    m(!0), u && u(s);
  }, v = (s) => {
    m(!1), d && d(s);
  }, w = (s) => {
    F(s.target.value), i && i(s);
  }, t = N ? "error-outline" : "", y = p ? "label-float" : "label-placeholder", B = f ? "label-focused" : "label-placeholder", R = f || p ? "legend-visible" : "";
  return /* @__PURE__ */ e.jsxs("div", { className: "input-container", style: { width: C }, children: [
    /* @__PURE__ */ e.jsx("label", { htmlFor: n, className: `${y} ${B} ${t}`, children: h }),
    /* @__PURE__ */ e.jsxs("div", { children: [
      /* @__PURE__ */ e.jsx(
        "input",
        {
          id: n,
          ref: x,
          defaultValue: r,
          type: "text",
          onFocus: $,
          onBlur: v,
          onChange: w,
          name: g,
          ...a && { "aria-describedby": `${n}-helperText` },
          ...I
        }
      ),
      l.suffix ? /* @__PURE__ */ e.jsx("div", { className: "input-container-suffix", children: l.suffix }) : null,
      /* @__PURE__ */ e.jsx("fieldset", { "aria-hidden": "true", className: t, children: /* @__PURE__ */ e.jsx("legend", { className: R, children: /* @__PURE__ */ e.jsx("span", { className: "legend-label", children: h }) }) })
    ] }),
    a && /* @__PURE__ */ e.jsx("p", { className: t, children: a })
  ] });
});
export {
  V as OneIncInput
};
